window.WebglMessageEvent = window.WebglMessageEvent==undefined?{}:window.WebglMessageEvent;
window.setWebglMessage = function(){
  window.WebglMessageEvent.STOP = {funcName:'stop',data:false};
  window.WebglMessageEvent.SHOW_EXTERIOR = {funcName:'showExterior',data:{autoRotate:false,sceneId:1,version:'low',colorId:'blue',marker:[1,2,3,4,5,6],fov:70,staff:true}};
  window.WebglMessageEvent.SHOW_INTERIOR = {funcName:'showInterior',data:{id:1},version:null};
  window.WebglMessageEvent.GET_ITEMS = {funcName:'getItems'};
  window.WebglMessageEvent.ADD_ITEM = {funcName:'addItem',data:{}};
  window.WebglMessageEvent.REMOVE_ITEM = {funcName:'removeItem',data:{}};
  window.WebglMessageEvent.LOAD_PROGESS = {type:'webgl',code:201,data:{progess:0}};
  window.WebglMessageEvent.LOAD_SUCCESS = {type:'webgl',code:202,data:'success'};
  window.WebglMessageEvent.LOAD_MEDIA = {type:'webgl',code:301,data:'/'};
  window.WebglMessageEvent.ADD_ITEMS = {funcName:'addItems',data:{items:[]}};
  window.WebglMessageEvent.SHOW_MARKET = {funcName:'showMarker',data:true};
  window.WebglMessageEvent.POSE ={funcName:'pose',data: {stop:true,type:0}};
  window.WebglMessageEvent.SET_INSIDE_LOCATION = {funcName:'setInsideLocation',data:0};
  window.WebglMessageEvent.SET_SCENE = {funcName:'setScene',data:''};
  window.WebglMessageEvent.REMOVE_ALL_ITEMS = {funcName:'removeAllItem'};
  window.WebglMessageEvent.SHOW_MARRKER = {
    funcName: "showMarker",
    data: true,
  };
  window.WebglMessageEvent.CLOSE_AMIMATIONS = {funcName:'closeAnimations'};
  window.WebglMessageEvent.SWITCH_WEBGL = {funcName:'switchWebgl',data:''};
  window.WebglMessageEvent.DRIVE = {funcName:'testDrive',data:false};
  window.WebglMessageEvent.FIRST_PERSPECTIVE = {funcName:'firstPerspective',data:false};
  WebglMessageEvent.SEND_UE_MESSAGE = {funcName:'sendUeMessage',data:''};
  WebglMessageEvent.ORIENTATION_LOCK = {funcName:'handleChangeOrientationLock',data:true};
  WebglMessageEvent.SHOW_POINT = {funcName:'showPoint',data:true};
  WebglMessageEvent.SET_EXTERIOR_COLOR = {funcName:'setExteriorColor',data:''};
  WebglMessageEvent.SET_INTERIOR_COLOR = {funcName:'setInteriorColor',data:''};
  WebglMessageEvent.SET_VERSION = {funcName:'setVersion',data:''};
}
window.setWebglMessage();